import {
  FETCH_EMPLOYEE_ATTENDANCE_REQUEST,
  FETCH_EMPLOYEE_ATTENDANCE_SUCCESS,
  FETCH_EMPLOYEE_ATTENDANCE_FAILURE,
  FETCH_EMPLOYEE_ATTENDANCE_EMPLOYEES_REQUEST,
  FETCH_EMPLOYEE_ATTENDANCE_EMPLOYEES_SUCCESS,
  FETCH_EMPLOYEE_ATTENDANCE_EMPLOYEES_FAILURE,
} from "../constants/EmployeeAttendanceConstants";

const initialState = {
  loading: false,
  data: [],
  error: null,

  empLoading: false,
  empData: [],
  empError: null,
};

const EmployeeAttendanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EMPLOYEE_ATTENDANCE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_EMPLOYEE_ATTENDANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };

    case FETCH_EMPLOYEE_ATTENDANCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case FETCH_EMPLOYEE_ATTENDANCE_EMPLOYEES_REQUEST:
      return {
        ...state,
        empLoading: true,
        empError: null,
      };

    case FETCH_EMPLOYEE_ATTENDANCE_EMPLOYEES_SUCCESS:
      return {
        ...state,
        empLoading: false,
        empData: action.payload,
        empError: null,
      };

    case FETCH_EMPLOYEE_ATTENDANCE_EMPLOYEES_FAILURE:
      return {
        ...state,
        empLoading: false,
        empError: action.payload,
      };

    default:
      return state;
  }
};

export default EmployeeAttendanceReducer;
